'use client';

import { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { CloseSvg } from '@/assets/Icons';
import { CSSTransition } from 'react-transition-group';
import checkOs from '@/helpers/checkOs';
import { Drawer, DrawerContent } from '@/components/ui/Drawer';

export default function AppInstallSticky() {
    const [show, setShow] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        if (
            !sessionStorage.getItem('hasShowDownloadApp') &&
            checkOs() !== 'mac' &&
            checkOs() !== 'ios'
        )
            setShow(true);
    }, []);

    const handleCloseClick = () => {
        setShow(false);
        sessionStorage.setItem('hasShowDownloadApp', 'true');
    };

    return (
        <CSSTransition
            in={show}
            timeout={300}
            classNames={{
                exit: 'opacity-100',
                exitActive:
                    'opacity-0 translate-y-20 transition-opacity transition-transform duration-300'
            }}
            unmountOnExit>
            <div className="bg-white border-2 border-[#F2F2F7] z-[5] flex items-center justify-between max-w-[434px] mx-auto p-4 fixed w-[calc(100%-16px)] bottom-24 rounded-2xl h-[72px] left-0 right-0">
                <div className="flex items-center gap-4 w-full">
                    <CloseSvg
                        className="block cursor-pointer h-6 w-6"
                        stroke="#AEAEB2"
                        onClick={handleCloseClick}
                    />
                    <img
                        className="w-9 h-9 aspect-square"
                        width="48"
                        height="48"
                        src="/logo.png"
                        alt="اپلیکیشن درسا"
                    />
                    <div className="text-sm font-bold text-surface-on">اپلیکیشن درسا</div>
                </div>
                <Button
                    size="sm"
                    className="text-base rounded-lg px-6"
                    onClick={() => setOpenDialog(true)}
                    id="install-app-from-sticky">
                    نصب
                </Button>
                <Drawer open={openDialog} onOpenChange={setOpenDialog}>
                    <DrawerContent className="max-w-[450px] px-6">
                        <div className="flex items-center gap-4 w-full">
                            <img
                                className="w-8 h-8 aspect-square"
                                width="32"
                                height="32"
                                src="/logo.png"
                                alt="اپلیکیشن درسا"
                            />
                            <div className="text-sm font-bold text-surface-on">اپلیکیشن درسا</div>
                        </div>
                        <div className="flex flex-col gap-3 py-8">
                            <a
                                href="https://click.adtrace.io/pyh2dqv"
                                rel="noreferrer"
                                target="_blank"
                                id="install-app-from-sticky-bazzar"
                                className="bg-[#F1F3F4] text-base font-semibold flex items-center justify-center gap-3 rounded-[8px] p-2.5 text-surface-on">
                                <img src="/images/appInstall/bazzar.png" alt="بازار" />
                                دریافت از بازار
                            </a>
                            <a
                                href="https://click.adtrace.io/ceqive2"
                                rel="noreferrer"
                                target="_blank"
                                id="install-app-from-sticky-myket"
                                className="bg-[#F1F3F4] text-base font-semibold flex items-center justify-center gap-3 rounded-[8px] p-2.5 text-surface-on">
                                <img src="/images/appInstall/myket.png" alt="مایکت" />
                                دریافت از مایکت
                            </a>
                            <a
                                download
                                href="https://click.adtrace.io/lmngcc8"
                                target="_blank"
                                rel="noreferrer"
                                id="install-app-from-sticky-direct"
                                className="bg-[#F1F3F4] text-base font-semibold flex items-center justify-center gap-3 rounded-[8px] p-2.5 text-surface-on">
                                <img src="/images/appInstall/direct.png" alt="مستقیم" />
                                دریافت مستقیم نسخه اندروید
                            </a>
                        </div>
                    </DrawerContent>
                </Drawer>
            </div>
        </CSSTransition>
    );
}
